export enum FeaturePermissions {
  /**
   * Can Access Full Configuration flows
   */
  FULL_CONFIGURATION_ACCESS = 'FULL_CONFIGURATION_ACCESS',

  /**
   * Can Access Renewals flows
   */
  RENEWALS_ACCESS = 'RENEWALS_ACCESS',

  /**
   * Can Access Partners flows
   */
  PARTNERS_ACCESS = 'PARTNERS_ACCESS',
}

export enum WorkOrderPermissions {
  /**
   * Can Create Work Orders
   */
  WORK_ORDERS_CREATE = 'WORK_ORDERS_CREATE',

  /**
   * Can View Work Orders drafts
   */
  WORK_ORDERS_DRAFTS_READ = 'WORK_ORDERS_DRAFTS_READ',

  /**
   * Can View Work Orders queue
   */
  WORK_ORDERS_QUEUE_READ = 'WORK_ORDERS_QUEUE_READ',

  /**
   * Can View Work Orders completed
   */
  WORK_ORDERS_COMPLETED_READ = 'WORK_ORDERS_COMPLETED_READ',

  /**
   * Can Update Work Orders drafts
   */
  WORK_ORDERS_DRAFTS_UPDATE = 'WORK_ORDERS_DRAFTS_UPDATE',

  /**
   * Can Update Work Orders queue
   */
  WORK_ORDERS_QUEUE_UPDATE = 'WORK_ORDERS_QUEUE_UPDATE',

  /**
   * Can Delete Work Orders drafts
   */
  WORK_ORDERS_DRAFTS_DELETE = 'WORK_ORDERS_DRAFTS_DELETE',

  /**
   * Can Prioritize Work Orders in queue
   */
  WORK_ORDERS_QUEUE_PRIORITIZATION = 'WORK_ORDERS_QUEUE_PRIORITIZATION',

  /**
   * Can View Work Orders Details
   */
  WORK_ORDERS_DETAILS_READ = 'WORK_ORDERS_DETAILS',

  /**
   * Can Export Work Orders Details
   */
  WORK_ORDERS_DETAILS_EXPORT = 'WORK_ORDERS_DETAILS_EXPORT',
}

export enum SalesOrderPermissions {
  /**
   * Can View Sales Orders Summary (does not include pricing)
   */
  SALES_ORDERS_SUMMARY_READ = 'SALES_ORDERS_SUMMARY_READ',

  /**
   * Can View Sales Orders Details (Bill + Shipping)
   */
  SALES_ORDER_DETAILS_READ = 'SALES_ORDER_DETAILS_READ',

  /**
   * Can View Salesforce Account / Parent Account
   */
  SALES_ORDERS_ACCOUNT_AND_PARENT_ACCOUNT_READ = 'SALES_ORDERS_ACCOUNT_AND_PARENT_ACCOUNT_READ',

  /**
   * Can Update Salesforce Account / Parent Account
   */
  SALES_ORDERS_ACCOUNT_AND_PARENT_ACCOUNT_UPDATE = 'SALES_ORDERS_ACCOUNT_AND_PARENT_ACCOUNT_UPDATE',

  /**
   * Can View Other Sales Order Summaries in Account
   */
  SALES_ORDERS_OTHER_SUMMARIES_READ = 'SALES_ORDERS_OTHER_SUMMARIES_READ',

  /**
   * Can View Other Sales Orders Summaries in Parent Account
   */
  SALES_ORDERS_OTHER_SUMMARIES_PARENT_ACCOUNT_READ = 'SALES_ORDERS_OTHER_SUMMARIES_PARENT_ACCOUNT_READ',

  /**
   * Can request access to other Sales Orders
   */
  SALES_ORDERS_REQUEST_ACCESS = 'SALES_ORDERS_REQUEST_ACCESS',

  /**
   * Can Export Sales Orders Details
   */
  SALES_ORDERS_DETAILS_EXPORT = 'SALES_ORDERS_DETAILS_EXPORT',
}

export enum DeviceGroupPermissions {
  /**
   * Can Create Device Groups
   */
  DEVICE_GROUPS_CREATE = 'DEVICE_GROUPS_CREATE',

  /**
   * Can View Device Groups
   */
  DEVICE_GROUPS_READ = 'DEVICE_GROUPS_READ',

  /**
   * Can Update Device Groups
   */
  DEVICE_GROUPS_UPDATE = 'DEVICE_GROUPS_UPDATE',

  /**
   * Can Delete Device Groups
   */
  DEVICE_GROUPS_DELETE = 'DEVICE_GROUPS_DELETE',

  /**
   * Can Join a Device Group
   */
  DEVICE_GROUPS_JOIN = 'DEVICE_GROUPS_JOIN',

  /**
   * Can Export Device Group Details
   */
  DEVICE_GROUPS_DETAILS_EXPORT = 'DEVICE_GROUPS_DETAILS_EXPORT',
}

export enum SoftwareSeatPermissions {
  /**
   * Can View Software Seats
   */
  SOFTWARE_SEATS_READ = 'SOFTWARE_SEATS_READ',

  /**
   * Can Update Software Seats
   */
  SOFTWARE_SEATS_UPDATE = 'SOFTWARE_SEATS_UPDATE',

  /**
   * Can Assign Software Seats
   */
  SOFTWARE_SEATS_ASSIGN = 'SOFTWARE_SEATS_ASSIGN',

  /**
   * Can Unassign Software Seats
   */
  SOFTWARE_SEATS_UNASSIGN = 'SOFTWARE_SEATS_UNASSIGN',

  /**
   * Can Reclaim Software Seats
   */
  SOFTWARE_SEATS_RECLAIM = 'SOFTWARE_SEATS_RECLAIM',

  /**
   * Can Export Software Seats Details
   */
  SOFTWARE_SEATS_DETAILS_EXPORT = 'SOFTWARE_SEATS_DETAILS_EXPORT',
}

export enum RMAProcessPermissions {
  /**
   * Can Start RMA Process
   */
  RMA_PROCESS_START = 'RMA_PROCESS_START',
}

export enum UserPermissions {
  /**
   * Can Create Users
   */
  USERS_CREATE = 'USERS_CREATE',

  /**
   * Can View Users
   */
  USERS_READ = 'USERS_READ',

  /**
   * Can Modify Users
   */
  USERS_UPDATE = 'USERS_UPDATE',

  /**
   * Can Delete Users
   */
  USERS_DELETE = 'USERS_DELETE',

  /**
   * Can Assign Users to Roles
   */
  USERS_ASSIGN_ROLES = 'USERS_ASSIGN_ROLES',

  /**
   * Can Self Assign Users to Roles
   */
  USERS_SELF_ASSIGN_ROLES = 'USERS_SELF_ASSIGN_ROLES',

  /**
   * Can download Self Assignments Audit Logs
   */
  USERS_SELF_ASSIGNMENTS_DOWNLOAD_AUDIT_LOGS = 'USERS_SELF_ASSIGNMENTS_DOWNLOAD_AUDIT_LOGS',
}

export enum DevicePermissions {
  /**
   * Can Register Devices
   */
  DEVICES_REGISTER = 'DEVICES_REGISTER',
  /**
   * Can View Registered Devices
   */
  REGISTERED_DEVICES_READ = 'REGISTERED_DEVICES_READ',
  /**
   * Can View Devices Details
   */
  DEVICE_DETAILS_READ = 'DEVICE_DETAILS_READ',
  /**
   * Can Export Devices Details
   */
  DEVICES_DETAILS_EXPORT = 'DEVICES_DETAILS_EXPORT',
}

export enum RegistrationFilePermissions {
  /**
   * Can View Registration Files
   */
  REGISTRATION_FILES_VIEW = 'REGISTRATION_FILES_VIEW',
  /**
   * Can Create Registration Files
   */
  REGISTRATION_FILES_CREATE = 'REGISTRATION_FILES_CREATE',
  /**
   * Can Send Registration Files
   */
  REGISTRATION_FILES_SEND = 'REGISTRATION_FILES_SEND',
  /**
   * Can Download Registration Files
   */
  REGISTRATION_FILES_DOWNLOAD = 'REGISTRATION_FILES_DOWNLOAD',
}

export enum NotificationPermissions {
  /**
   * Can receive Work Order Notifications
   */
  NOTIFICATIONS_WORK_ORDERS = 'NOTIFICATIONS_WORK_ORDERS',

  /**
   * Can receive Groups / Subgroups / Software Seats Notifications
   */
  NOTIFICATIONS_DEVICE_GROUPS_SOFTWARE_SEATS = 'NOTIFICATIONS_DEVICE_GROUPS_SOFTWARE_SEATS',

  /**
   * Can receive Renewal / Billing Notifications
   */
  NOTIFICATIONS_RENEWAL_BILLING = 'NOTIFICATIONS_RENEWAL_BILLING',

  /**
   * Can Manage Notifications
   */
  NOTIFICATIONS_MANAGE = 'NOTIFICATIONS_MANAGE',
}

export enum AdminPermissions {
  /**
   * Can Access Admin Tools
   */
  ADMIN_TOOLS_ACCESS = 'ADMIN_TOOLS_ACCESS',
}

export const superAdminPermissions = [
  FeaturePermissions.FULL_CONFIGURATION_ACCESS,
  WorkOrderPermissions.WORK_ORDERS_CREATE,
  WorkOrderPermissions.WORK_ORDERS_DRAFTS_READ,
  WorkOrderPermissions.WORK_ORDERS_QUEUE_READ,
  WorkOrderPermissions.WORK_ORDERS_COMPLETED_READ,
  WorkOrderPermissions.WORK_ORDERS_DRAFTS_UPDATE,
  WorkOrderPermissions.WORK_ORDERS_DRAFTS_DELETE,
  WorkOrderPermissions.WORK_ORDERS_QUEUE_PRIORITIZATION,
  WorkOrderPermissions.WORK_ORDERS_DETAILS_READ,
  WorkOrderPermissions.WORK_ORDERS_DETAILS_EXPORT,
  SalesOrderPermissions.SALES_ORDERS_SUMMARY_READ,
  SalesOrderPermissions.SALES_ORDERS_ACCOUNT_AND_PARENT_ACCOUNT_READ,
  SalesOrderPermissions.SALES_ORDERS_ACCOUNT_AND_PARENT_ACCOUNT_UPDATE,
  SalesOrderPermissions.SALES_ORDERS_OTHER_SUMMARIES_READ,
  SalesOrderPermissions.SALES_ORDERS_OTHER_SUMMARIES_PARENT_ACCOUNT_READ,
  SalesOrderPermissions.SALES_ORDERS_DETAILS_EXPORT,
  DeviceGroupPermissions.DEVICE_GROUPS_CREATE,
  DeviceGroupPermissions.DEVICE_GROUPS_READ,
  DeviceGroupPermissions.DEVICE_GROUPS_UPDATE,
  DeviceGroupPermissions.DEVICE_GROUPS_DELETE,
  SoftwareSeatPermissions.SOFTWARE_SEATS_READ,
  SoftwareSeatPermissions.SOFTWARE_SEATS_UPDATE,
  SoftwareSeatPermissions.SOFTWARE_SEATS_ASSIGN,
  SoftwareSeatPermissions.SOFTWARE_SEATS_UNASSIGN,
  SoftwareSeatPermissions.SOFTWARE_SEATS_RECLAIM,
  RMAProcessPermissions.RMA_PROCESS_START,
  UserPermissions.USERS_CREATE,
  UserPermissions.USERS_READ,
  UserPermissions.USERS_UPDATE,
  UserPermissions.USERS_DELETE,
  UserPermissions.USERS_ASSIGN_ROLES,
  UserPermissions.USERS_SELF_ASSIGN_ROLES,
  UserPermissions.USERS_SELF_ASSIGNMENTS_DOWNLOAD_AUDIT_LOGS,
  NotificationPermissions.NOTIFICATIONS_WORK_ORDERS,
  NotificationPermissions.NOTIFICATIONS_DEVICE_GROUPS_SOFTWARE_SEATS,
  NotificationPermissions.NOTIFICATIONS_RENEWAL_BILLING,
  NotificationPermissions.NOTIFICATIONS_MANAGE,
  DevicePermissions.DEVICE_DETAILS_READ,
  AdminPermissions.ADMIN_TOOLS_ACCESS,
];

export const itAdminPermissions = [
  FeaturePermissions.FULL_CONFIGURATION_ACCESS,
  WorkOrderPermissions.WORK_ORDERS_DRAFTS_READ,
  WorkOrderPermissions.WORK_ORDERS_QUEUE_READ,
  WorkOrderPermissions.WORK_ORDERS_COMPLETED_READ,
  WorkOrderPermissions.WORK_ORDERS_DETAILS_READ,
  WorkOrderPermissions.WORK_ORDERS_DETAILS_EXPORT,
  SalesOrderPermissions.SALES_ORDERS_SUMMARY_READ,
  SalesOrderPermissions.SALES_ORDERS_ACCOUNT_AND_PARENT_ACCOUNT_READ,
  SalesOrderPermissions.SALES_ORDERS_OTHER_SUMMARIES_READ,
  SalesOrderPermissions.SALES_ORDERS_OTHER_SUMMARIES_PARENT_ACCOUNT_READ,
  SalesOrderPermissions.SALES_ORDERS_DETAILS_EXPORT,
  DeviceGroupPermissions.DEVICE_GROUPS_READ,
  SoftwareSeatPermissions.SOFTWARE_SEATS_READ,
  SoftwareSeatPermissions.SOFTWARE_SEATS_UNASSIGN,
  SoftwareSeatPermissions.SOFTWARE_SEATS_RECLAIM,
  RMAProcessPermissions.RMA_PROCESS_START,
  UserPermissions.USERS_CREATE,
  UserPermissions.USERS_READ,
  UserPermissions.USERS_ASSIGN_ROLES,
  UserPermissions.USERS_SELF_ASSIGN_ROLES,
  NotificationPermissions.NOTIFICATIONS_WORK_ORDERS,
  NotificationPermissions.NOTIFICATIONS_DEVICE_GROUPS_SOFTWARE_SEATS,
  NotificationPermissions.NOTIFICATIONS_RENEWAL_BILLING,
  DevicePermissions.DEVICE_DETAILS_READ,
  AdminPermissions.ADMIN_TOOLS_ACCESS,
];

export const supportStandardPermissions = [
  FeaturePermissions.FULL_CONFIGURATION_ACCESS,
  WorkOrderPermissions.WORK_ORDERS_QUEUE_READ,
  WorkOrderPermissions.WORK_ORDERS_COMPLETED_READ,
  WorkOrderPermissions.WORK_ORDERS_DETAILS_READ,
  WorkOrderPermissions.WORK_ORDERS_DETAILS_EXPORT,
  SalesOrderPermissions.SALES_ORDERS_SUMMARY_READ,
  SalesOrderPermissions.SALES_ORDERS_ACCOUNT_AND_PARENT_ACCOUNT_READ,
  SalesOrderPermissions.SALES_ORDERS_OTHER_SUMMARIES_READ,
  SalesOrderPermissions.SALES_ORDERS_OTHER_SUMMARIES_PARENT_ACCOUNT_READ,
  SalesOrderPermissions.SALES_ORDERS_DETAILS_EXPORT,
  DeviceGroupPermissions.DEVICE_GROUPS_READ,
  SoftwareSeatPermissions.SOFTWARE_SEATS_READ,
  SoftwareSeatPermissions.SOFTWARE_SEATS_UNASSIGN,
  SoftwareSeatPermissions.SOFTWARE_SEATS_RECLAIM,
  RMAProcessPermissions.RMA_PROCESS_START,
  UserPermissions.USERS_CREATE,
  UserPermissions.USERS_READ,
  UserPermissions.USERS_ASSIGN_ROLES,
  UserPermissions.USERS_SELF_ASSIGN_ROLES,
  NotificationPermissions.NOTIFICATIONS_WORK_ORDERS,
  NotificationPermissions.NOTIFICATIONS_DEVICE_GROUPS_SOFTWARE_SEATS,
  NotificationPermissions.NOTIFICATIONS_RENEWAL_BILLING,
  DevicePermissions.DEVICE_DETAILS_READ,
  AdminPermissions.ADMIN_TOOLS_ACCESS,
];

export const customerSuccessPermissions = [
  FeaturePermissions.FULL_CONFIGURATION_ACCESS,
  WorkOrderPermissions.WORK_ORDERS_QUEUE_READ,
  WorkOrderPermissions.WORK_ORDERS_COMPLETED_READ,
  WorkOrderPermissions.WORK_ORDERS_DETAILS_READ,
  WorkOrderPermissions.WORK_ORDERS_DETAILS_EXPORT,
  SalesOrderPermissions.SALES_ORDERS_SUMMARY_READ,
  SalesOrderPermissions.SALES_ORDERS_ACCOUNT_AND_PARENT_ACCOUNT_READ,
  SalesOrderPermissions.SALES_ORDERS_OTHER_SUMMARIES_READ,
  SalesOrderPermissions.SALES_ORDERS_OTHER_SUMMARIES_PARENT_ACCOUNT_READ,
  SalesOrderPermissions.SALES_ORDERS_DETAILS_EXPORT,
  DeviceGroupPermissions.DEVICE_GROUPS_READ,
  SoftwareSeatPermissions.SOFTWARE_SEATS_READ,
  SoftwareSeatPermissions.SOFTWARE_SEATS_UNASSIGN,
  UserPermissions.USERS_READ,
  UserPermissions.USERS_SELF_ASSIGN_ROLES,
  NotificationPermissions.NOTIFICATIONS_WORK_ORDERS,
  NotificationPermissions.NOTIFICATIONS_DEVICE_GROUPS_SOFTWARE_SEATS,
  NotificationPermissions.NOTIFICATIONS_RENEWAL_BILLING,
  DevicePermissions.DEVICE_DETAILS_READ,
  AdminPermissions.ADMIN_TOOLS_ACCESS,
];

export const workOrderCreatorPermissions = [
  FeaturePermissions.FULL_CONFIGURATION_ACCESS,
  WorkOrderPermissions.WORK_ORDERS_CREATE,
  WorkOrderPermissions.WORK_ORDERS_DRAFTS_READ,
  WorkOrderPermissions.WORK_ORDERS_QUEUE_READ,
  WorkOrderPermissions.WORK_ORDERS_COMPLETED_READ,
  WorkOrderPermissions.WORK_ORDERS_DRAFTS_UPDATE,
  WorkOrderPermissions.WORK_ORDERS_DRAFTS_DELETE,
  WorkOrderPermissions.WORK_ORDERS_DETAILS_READ,
  WorkOrderPermissions.WORK_ORDERS_DETAILS_EXPORT,
  SalesOrderPermissions.SALES_ORDERS_SUMMARY_READ,
  SalesOrderPermissions.SALES_ORDERS_ACCOUNT_AND_PARENT_ACCOUNT_READ,
  SalesOrderPermissions.SALES_ORDERS_OTHER_SUMMARIES_READ,
  SalesOrderPermissions.SALES_ORDERS_OTHER_SUMMARIES_PARENT_ACCOUNT_READ,
  SalesOrderPermissions.SALES_ORDERS_REQUEST_ACCESS,
  SalesOrderPermissions.SALES_ORDERS_DETAILS_EXPORT,
  DeviceGroupPermissions.DEVICE_GROUPS_CREATE,
  DeviceGroupPermissions.DEVICE_GROUPS_READ,
  DeviceGroupPermissions.DEVICE_GROUPS_UPDATE,
  DeviceGroupPermissions.DEVICE_GROUPS_DELETE,
  SoftwareSeatPermissions.SOFTWARE_SEATS_READ,
  SoftwareSeatPermissions.SOFTWARE_SEATS_UPDATE,
  SoftwareSeatPermissions.SOFTWARE_SEATS_ASSIGN,
  SoftwareSeatPermissions.SOFTWARE_SEATS_RECLAIM,
  UserPermissions.USERS_READ,
  NotificationPermissions.NOTIFICATIONS_WORK_ORDERS,
  DevicePermissions.DEVICE_DETAILS_READ,
  AdminPermissions.ADMIN_TOOLS_ACCESS,
];

export const workOrderManagerPermissions = [
  FeaturePermissions.FULL_CONFIGURATION_ACCESS,
  WorkOrderPermissions.WORK_ORDERS_DRAFTS_READ,
  WorkOrderPermissions.WORK_ORDERS_QUEUE_READ,
  WorkOrderPermissions.WORK_ORDERS_COMPLETED_READ,
  WorkOrderPermissions.WORK_ORDERS_QUEUE_PRIORITIZATION,
  WorkOrderPermissions.WORK_ORDERS_DETAILS_READ,
  WorkOrderPermissions.WORK_ORDERS_DETAILS_EXPORT,
  SalesOrderPermissions.SALES_ORDERS_SUMMARY_READ,
  SalesOrderPermissions.SALES_ORDERS_ACCOUNT_AND_PARENT_ACCOUNT_READ,
  SalesOrderPermissions.SALES_ORDERS_DETAILS_EXPORT,
  DeviceGroupPermissions.DEVICE_GROUPS_READ,
  SoftwareSeatPermissions.SOFTWARE_SEATS_READ,
  UserPermissions.USERS_READ,
  NotificationPermissions.NOTIFICATIONS_WORK_ORDERS,
  DevicePermissions.DEVICE_DETAILS_READ,
  AdminPermissions.ADMIN_TOOLS_ACCESS,
];

export const warehousePartnerPermissions = [
  FeaturePermissions.PARTNERS_ACCESS,
  FeaturePermissions.FULL_CONFIGURATION_ACCESS,
  WorkOrderPermissions.WORK_ORDERS_QUEUE_READ,
  WorkOrderPermissions.WORK_ORDERS_COMPLETED_READ,
  WorkOrderPermissions.WORK_ORDERS_DETAILS_READ,
  SalesOrderPermissions.SALES_ORDERS_SUMMARY_READ,
  SalesOrderPermissions.SALES_ORDERS_ACCOUNT_AND_PARENT_ACCOUNT_READ,
  UserPermissions.USERS_READ,
  UserPermissions.USERS_CREATE,
  UserPermissions.USERS_ASSIGN_ROLES,
  NotificationPermissions.NOTIFICATIONS_WORK_ORDERS,
];

export const endUserSoftwareContactPermissions = [
  FeaturePermissions.RENEWALS_ACCESS,
  SalesOrderPermissions.SALES_ORDERS_SUMMARY_READ,
  SalesOrderPermissions.SALES_ORDERS_ACCOUNT_AND_PARENT_ACCOUNT_READ,
  SalesOrderPermissions.SALES_ORDERS_OTHER_SUMMARIES_READ,
  SalesOrderPermissions.SALES_ORDERS_OTHER_SUMMARIES_PARENT_ACCOUNT_READ,
  SalesOrderPermissions.SALES_ORDERS_REQUEST_ACCESS,
  SalesOrderPermissions.SALES_ORDERS_DETAILS_EXPORT,
  DeviceGroupPermissions.DEVICE_GROUPS_CREATE,
  DeviceGroupPermissions.DEVICE_GROUPS_READ,
  DeviceGroupPermissions.DEVICE_GROUPS_UPDATE,
  DeviceGroupPermissions.DEVICE_GROUPS_DETAILS_EXPORT,
  SoftwareSeatPermissions.SOFTWARE_SEATS_READ,
  SoftwareSeatPermissions.SOFTWARE_SEATS_UPDATE,
  SoftwareSeatPermissions.SOFTWARE_SEATS_ASSIGN,
  SoftwareSeatPermissions.SOFTWARE_SEATS_RECLAIM,
  RMAProcessPermissions.RMA_PROCESS_START,
  UserPermissions.USERS_READ,
  UserPermissions.USERS_CREATE,
  UserPermissions.USERS_UPDATE,
  UserPermissions.USERS_DELETE,
  UserPermissions.USERS_ASSIGN_ROLES,
  NotificationPermissions.NOTIFICATIONS_WORK_ORDERS,
  NotificationPermissions.NOTIFICATIONS_DEVICE_GROUPS_SOFTWARE_SEATS,
  NotificationPermissions.NOTIFICATIONS_RENEWAL_BILLING,
  NotificationPermissions.NOTIFICATIONS_MANAGE,
  RegistrationFilePermissions.REGISTRATION_FILES_VIEW,
  RegistrationFilePermissions.REGISTRATION_FILES_CREATE,
  RegistrationFilePermissions.REGISTRATION_FILES_DOWNLOAD,
  RegistrationFilePermissions.REGISTRATION_FILES_SEND,
  DevicePermissions.REGISTERED_DEVICES_READ,
  DevicePermissions.DEVICE_DETAILS_READ,
  DevicePermissions.DEVICES_DETAILS_EXPORT,
];

export const billingContactPermissions = [
  FeaturePermissions.RENEWALS_ACCESS,
  SalesOrderPermissions.SALES_ORDERS_SUMMARY_READ,
  SalesOrderPermissions.SALES_ORDERS_ACCOUNT_AND_PARENT_ACCOUNT_READ,
  SalesOrderPermissions.SALES_ORDERS_OTHER_SUMMARIES_READ,
  SalesOrderPermissions.SALES_ORDERS_OTHER_SUMMARIES_PARENT_ACCOUNT_READ,
  DeviceGroupPermissions.DEVICE_GROUPS_READ,
  SoftwareSeatPermissions.SOFTWARE_SEATS_READ,
  UserPermissions.USERS_READ,
  NotificationPermissions.NOTIFICATIONS_WORK_ORDERS,
  NotificationPermissions.NOTIFICATIONS_DEVICE_GROUPS_SOFTWARE_SEATS,
  NotificationPermissions.NOTIFICATIONS_RENEWAL_BILLING,
  NotificationPermissions.NOTIFICATIONS_MANAGE,
  DevicePermissions.DEVICE_DETAILS_READ,
];

export const shippingContactPermissions = [
  FeaturePermissions.RENEWALS_ACCESS,
  SalesOrderPermissions.SALES_ORDERS_SUMMARY_READ,
  SalesOrderPermissions.SALES_ORDERS_ACCOUNT_AND_PARENT_ACCOUNT_READ,
  DeviceGroupPermissions.DEVICE_GROUPS_READ,
  SoftwareSeatPermissions.SOFTWARE_SEATS_READ,
  UserPermissions.USERS_READ,
  NotificationPermissions.NOTIFICATIONS_WORK_ORDERS,
  NotificationPermissions.NOTIFICATIONS_DEVICE_GROUPS_SOFTWARE_SEATS,
  DevicePermissions.DEVICE_DETAILS_READ,
];

export const salesOrderManagerPermissions = [
  FeaturePermissions.RENEWALS_ACCESS,
  SalesOrderPermissions.SALES_ORDERS_SUMMARY_READ,
  SalesOrderPermissions.SALES_ORDERS_ACCOUNT_AND_PARENT_ACCOUNT_READ,
  SalesOrderPermissions.SALES_ORDERS_OTHER_SUMMARIES_READ,
  SalesOrderPermissions.SALES_ORDERS_OTHER_SUMMARIES_PARENT_ACCOUNT_READ,
  SalesOrderPermissions.SALES_ORDERS_REQUEST_ACCESS,
  SalesOrderPermissions.SALES_ORDERS_DETAILS_EXPORT,
  DeviceGroupPermissions.DEVICE_GROUPS_CREATE,
  DeviceGroupPermissions.DEVICE_GROUPS_READ,
  DeviceGroupPermissions.DEVICE_GROUPS_UPDATE,
  DeviceGroupPermissions.DEVICE_GROUPS_DETAILS_EXPORT,
  SoftwareSeatPermissions.SOFTWARE_SEATS_READ,
  SoftwareSeatPermissions.SOFTWARE_SEATS_UPDATE,
  SoftwareSeatPermissions.SOFTWARE_SEATS_ASSIGN,
  SoftwareSeatPermissions.SOFTWARE_SEATS_RECLAIM,
  RMAProcessPermissions.RMA_PROCESS_START,
  UserPermissions.USERS_READ,
  UserPermissions.USERS_CREATE,
  UserPermissions.USERS_ASSIGN_ROLES,
  NotificationPermissions.NOTIFICATIONS_DEVICE_GROUPS_SOFTWARE_SEATS,
  NotificationPermissions.NOTIFICATIONS_RENEWAL_BILLING,
  DevicePermissions.DEVICE_DETAILS_READ,
  DevicePermissions.DEVICES_DETAILS_EXPORT,
  RegistrationFilePermissions.REGISTRATION_FILES_VIEW,
  RegistrationFilePermissions.REGISTRATION_FILES_CREATE,
  RegistrationFilePermissions.REGISTRATION_FILES_DOWNLOAD,
  RegistrationFilePermissions.REGISTRATION_FILES_SEND,
  DevicePermissions.REGISTERED_DEVICES_READ,
];

export const viewOnlySalesOrderManagerPermissions = [
  FeaturePermissions.RENEWALS_ACCESS,
  SalesOrderPermissions.SALES_ORDERS_SUMMARY_READ,
  SalesOrderPermissions.SALES_ORDERS_ACCOUNT_AND_PARENT_ACCOUNT_READ,
  SalesOrderPermissions.SALES_ORDERS_OTHER_SUMMARIES_READ,
  SalesOrderPermissions.SALES_ORDERS_OTHER_SUMMARIES_PARENT_ACCOUNT_READ,
  SalesOrderPermissions.SALES_ORDERS_REQUEST_ACCESS,
  SalesOrderPermissions.SALES_ORDERS_DETAILS_EXPORT,
  DeviceGroupPermissions.DEVICE_GROUPS_READ,
  DeviceGroupPermissions.DEVICE_GROUPS_DETAILS_EXPORT,
  SoftwareSeatPermissions.SOFTWARE_SEATS_READ,
  RMAProcessPermissions.RMA_PROCESS_START,
  UserPermissions.USERS_READ,
  NotificationPermissions.NOTIFICATIONS_DEVICE_GROUPS_SOFTWARE_SEATS,
  NotificationPermissions.NOTIFICATIONS_RENEWAL_BILLING,
  DevicePermissions.DEVICE_DETAILS_READ,
  DevicePermissions.DEVICES_DETAILS_EXPORT,
  RegistrationFilePermissions.REGISTRATION_FILES_VIEW,
];

export const temporarySalesOrderManagerPermissions = [
  FeaturePermissions.RENEWALS_ACCESS,
  SalesOrderPermissions.SALES_ORDERS_SUMMARY_READ,
  SalesOrderPermissions.SALES_ORDERS_ACCOUNT_AND_PARENT_ACCOUNT_READ,
  SalesOrderPermissions.SALES_ORDERS_DETAILS_EXPORT,
  DeviceGroupPermissions.DEVICE_GROUPS_CREATE,
  DeviceGroupPermissions.DEVICE_GROUPS_READ,
  DeviceGroupPermissions.DEVICE_GROUPS_UPDATE,
  DeviceGroupPermissions.DEVICE_GROUPS_DETAILS_EXPORT,
  SoftwareSeatPermissions.SOFTWARE_SEATS_READ,
  SoftwareSeatPermissions.SOFTWARE_SEATS_UPDATE,
  SoftwareSeatPermissions.SOFTWARE_SEATS_ASSIGN,
  SoftwareSeatPermissions.SOFTWARE_SEATS_RECLAIM,
  UserPermissions.USERS_READ,
  NotificationPermissions.NOTIFICATIONS_DEVICE_GROUPS_SOFTWARE_SEATS,
  NotificationPermissions.NOTIFICATIONS_RENEWAL_BILLING,
  RegistrationFilePermissions.REGISTRATION_FILES_VIEW,
  RegistrationFilePermissions.REGISTRATION_FILES_CREATE,
  RegistrationFilePermissions.REGISTRATION_FILES_DOWNLOAD,
  RegistrationFilePermissions.REGISTRATION_FILES_SEND,
  DevicePermissions.REGISTERED_DEVICES_READ,
  DevicePermissions.DEVICE_DETAILS_READ,
  DevicePermissions.DEVICES_DETAILS_EXPORT,
];

export type Permissions =
  | AdminPermissions
  | DeviceGroupPermissions
  | DevicePermissions
  | FeaturePermissions
  | NotificationPermissions
  | RegistrationFilePermissions
  | RMAProcessPermissions
  | SalesOrderPermissions
  | SoftwareSeatPermissions
  | UserPermissions
  | WorkOrderPermissions;

/* Please note that this enum is sorted by role relevance. */
export enum PermissionsGroupName {
  SUPER_ADMIN = 'Super Admin',
  IT_ADMIN = 'IT Admin',
  SUPPORT_STANDARD = 'Support Standard',
  CUSTOMER_SUCCESS = 'Customer Success',
  WORK_ORDER_CREATOR = 'Work Order Creator',
  WORK_ORDER_MANAGER = 'Work Order Manager',
  WAREHOUSE_PARTNER = 'Warehouse Partner',
  END_USER_SOFTWARE_CONTACT = 'End User Software Contact',
  BILLING_CONTACT = 'Billing Contact',
  SHIPPING_CONTACT = 'Shipping Contact',
  SALES_ORDER_MANAGER = 'Sales Order Manager',
  VIEW_ONLY_SALES_ORDER_MANAGER = 'View Only Sales Order Manager',
  TEMPORARY_SALES_ORDER_MANAGER = 'Temporary Sales Order Manager',
}

export const PERMISSIONS_GROUPS_SHORT_NAMES: Record<
  PermissionsGroupName,
  string
> = {
  [PermissionsGroupName.SUPER_ADMIN]: 'Super Admin',
  [PermissionsGroupName.IT_ADMIN]: 'IT Admin',
  [PermissionsGroupName.SUPPORT_STANDARD]: 'Support Standard',
  [PermissionsGroupName.CUSTOMER_SUCCESS]: 'Customer Success',
  [PermissionsGroupName.WORK_ORDER_CREATOR]: 'Work Order Creator',
  [PermissionsGroupName.WORK_ORDER_MANAGER]: 'Work Order Manager',
  [PermissionsGroupName.WAREHOUSE_PARTNER]: 'Warehouse Partner',
  [PermissionsGroupName.END_USER_SOFTWARE_CONTACT]: 'End User Software Contact',
  [PermissionsGroupName.BILLING_CONTACT]: 'Billing Contact',
  [PermissionsGroupName.SHIPPING_CONTACT]: 'Shipping Contact',
  [PermissionsGroupName.SALES_ORDER_MANAGER]: 'Manager',
  [PermissionsGroupName.VIEW_ONLY_SALES_ORDER_MANAGER]: 'View Only',
  [PermissionsGroupName.TEMPORARY_SALES_ORDER_MANAGER]: 'Temporary Manager',
};

/**
 * Array containing all zSpace sales order related permissions groups in a descending role sorting criteria
 */
export const ALL_SALES_ORDER_RELATED_PERMISSIONS_GROUPS: PermissionsGroupName[] =
  [
    PermissionsGroupName.END_USER_SOFTWARE_CONTACT,
    PermissionsGroupName.BILLING_CONTACT,
    PermissionsGroupName.SHIPPING_CONTACT,
    PermissionsGroupName.SALES_ORDER_MANAGER,
    PermissionsGroupName.TEMPORARY_SALES_ORDER_MANAGER,
    PermissionsGroupName.VIEW_ONLY_SALES_ORDER_MANAGER,
  ];

/**
 * Array containing all zSpace staff permissions groups in a descending role sorting criteria
 */
export const ALL_ZSPACE_STAFF_PERMISSIONS_GROUPS: PermissionsGroupName[] = [
  PermissionsGroupName.SUPER_ADMIN,
  PermissionsGroupName.IT_ADMIN,
  PermissionsGroupName.SUPPORT_STANDARD,
  PermissionsGroupName.CUSTOMER_SUCCESS,
  PermissionsGroupName.WORK_ORDER_CREATOR,
  PermissionsGroupName.WORK_ORDER_MANAGER,
];

/**
 * Array containing all zSpace internal permissions groups (both sales order related or not)
 */
export const ALL_ZSPACE_INTERNAL_PERMISSIONS_GROUPS: PermissionsGroupName[] =
  ALL_ZSPACE_STAFF_PERMISSIONS_GROUPS.concat(
    ALL_SALES_ORDER_RELATED_PERMISSIONS_GROUPS
  );

/**
 * Array containing all partners permissions groups in a descending role sorting criteria
 */
export const ALL_PARTNER_PERMISSIONS_GROUPS: PermissionsGroupName[] = [
  PermissionsGroupName.WAREHOUSE_PARTNER,
];

/**
 * Array containing all zSpace internal permissions groups and all partner permissions groups in
 * a descending role sorting criteria
 */
export const ALL_ZSPACE_STAFF_AND_PARTNER_PERMISSIONS_GROUPS = [
  ...ALL_ZSPACE_STAFF_PERMISSIONS_GROUPS,
  ...ALL_PARTNER_PERMISSIONS_GROUPS,
];

export const NETSUITE_DERIVED_PERMISSIONS_GROUPS: PermissionsGroupName[] = [
  PermissionsGroupName.END_USER_SOFTWARE_CONTACT,
  PermissionsGroupName.BILLING_CONTACT,
  PermissionsGroupName.SHIPPING_CONTACT,
];

/**
 * Array containing all system defined permissions groups
 */
export const SYSTEM_DEFINED_PERMISSIONS_GROUPS: PermissionsGroupName[] = [
  PermissionsGroupName.SALES_ORDER_MANAGER,
  PermissionsGroupName.TEMPORARY_SALES_ORDER_MANAGER,
  PermissionsGroupName.VIEW_ONLY_SALES_ORDER_MANAGER,
];

/**
 * Array containing all customer manager permissions groups
 */
export const ALL_CUSTOMER_MANAGER_PERMISSIONS_GROUPS: PermissionsGroupName[] = [
  PermissionsGroupName.END_USER_SOFTWARE_CONTACT,
  PermissionsGroupName.SALES_ORDER_MANAGER,
  PermissionsGroupName.TEMPORARY_SALES_ORDER_MANAGER,
];

/**
 * Permissions groups that grant `isManager: true` on the zCentral org-access
 * endpoint. Excludes TEMPORARY (time-bound by design) and VIEW_ONLY (no
 * management capabilities).
 *
 * Order matters: it defines role precedence when a user belongs to more than
 * one group. The first match wins (END_USER_SOFTWARE_CONTACT over
 * SALES_ORDER_MANAGER).
 */
export const ZCENTRAL_MANAGER_PERMISSIONS_GROUPS: PermissionsGroupName[] = [
  PermissionsGroupName.END_USER_SOFTWARE_CONTACT,
  PermissionsGroupName.SALES_ORDER_MANAGER,
];

/**
 * Manager role reported by the zCentral org-access endpoint for internal
 * (@zspace.com) users, who are always treated as org managers.
 */
export const ZCENTRAL_INTERNAL_MANAGER_ROLE = 'Internal';
